import { Cash, Online } from "../../../../../utils/Constant";

export type PettyCashExpenseFieldConfig = {
  name: string;
  label: string;
  type: "text" | "select" | "date" | "file" | "number" | "textarea";
  col?: number;
  options?: { value: string; label: string }[];
  dynamicOptions?: "categoryType";
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  accept?: any;
  when?: (values: any) => boolean;
};

export const pettyCashFormFields: PettyCashExpenseFieldConfig[] = [
  {
    name: "pettyCashDate",
    label: "Date",
    type: "date",
    col: 6,
  },
  {
    name: "categoryType",
    label: "Category",
    type: "select",
    col: 6,
    dynamicOptions: "categoryType", // key used to resolve options
    placeholder: "Select Category Type",
  },
  {
    name: "amount",
    label: "Amount",
    type: "number",
    col: 6,
  },
  {
    name: "paymentMode",
    label: "Payment Mode",
    type: "select",
    col: 6,
    options: [
      {
        value: "1",
        label: Cash,
      },
      {
        value: "2",
        label: Online,
      },
    ],
    placeholder: "Select Payment Mode",
  },
  {
    name: "pettyCashAttachment",
    label: "Attachment",
    type: "file",
    col: 12,
    accept: ".pdf,.jpg,.jpeg,.png",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    rows: 2,
    col: 12,
    placeholder: "Enter description",
  },
];
